<template>
  <div>
    <!-- <v-btn
        v-if="$admin.can('md-makes.create')"
        color="primary"
        dark
        @click="openModal"
      >
        {{ $t("add_new") }}
      </v-btn> -->
    <!-- v-if="isVisibleDialog" -->
    <v-dialog
      v-model="isVisibleDialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="$admin.can('tenant-configurations.create')"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="openModal"
        >
          {{ $t("add_new") }}
        </v-btn>
      </template>

      <v-form
        ref="form"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h3">{{ $t("add_new") }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  v-if="authUser.isAdmin"
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="item.tenant_id"
                    dense
                    :disabled="tenantLoading"
                    :loading="tenantLoading"
                    :items="tenantsList"
                    item-text="name"
                    item-value="id"
                    :label="$t('select_tenant_*')"
                    clearable
                    :rules="[rules.required]"
                    @change="onTenantChange"
                  />
                </v-col>
                <v-col
                  v-if="authUser.isAdmin"
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="item.parent_tenant_id"
                    dense
                    :disabled="isParentTenantLoading"
                    :loading="isParentTenantLoading"
                    :items="item.tenant_id ? parentTenantsList : []"
                    item-text="parent_tenant_name"
                    item-value="parent_tenant"
                    :label="$t('select_parent_tenant_*')"
                    clearable
                    :rules="[rules.required]"
                    @change="onParentTenantChange"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="item.vehicle_ids"
                    dense
                    :disabled="isVehicleLoading"
                    :loading="isVehicleLoading"
                    :items="item.parent_tenant_id ? vehicleList : []"
                    item-text="vehicle_name"
                    item-value="id"
                    :label="$t('select_vehicle_*')"
                    clearable
                    multiple
                    :rules="[rules.required]"
                  >
                    <!-- selected -->
                    <template v-slot:selection="data">
                      <span
                        v-if="data.index === 0"
                        class="selected"
                      >
                        <span>{{ data.item.vehicle_name }}</span>
                      </span>
                      <span
                        v-if="data.index === 1"
                        class="grey--text text-caption"
                      >
                        (+{{ item.vehicle_ids.length - 1 }} others)
                      </span>
                    </template>
                    <!-- selected -->
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <small>{{ $t("indicates_required_field") }}</small>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="closeForm()"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="isLoading"
              @click="saveItem(item)"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "@/mixins/validationRules";

export default {
  mixins: [validationRules],
  props: {
    filterOptions: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isVisibleDialog: false,
      item: {},
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "vehicleAssign/getLoading",
      tenantLoading: "tenantsRelationship/getLoading",
      tenantsList: "tenantsRelationship/getChildTenantList",
      //
      isParentTenantLoading: "tenantsRelationship/getLoading",
      parentTenantsList: "tenantsRelationship/getList",
      isVehicleLoading: "vehicleAssign/getLoading",
      vehicleList: "vehicleAssign/getVehicleOptions",
    }),
  },

  async mounted() {
    await this.$store.dispatch("tenantsRelationship/childTenantList");
  },

  methods: {
    openModal() {
      this.isVisibleDialog = !this.isVisibleDialog;
    },
    closeForm() {
      this.$refs.form.reset();
      this.isVisibleDialog = false;
    },
    async saveItem(item) {
      if (this.$refs.form.validate()) {
        let params = {
          ...item,
        };
        await this.$store
          .dispatch("vehicleAssign/add", params)
          .then(() => {
            this.closeForm();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
          });
      }
    },
    onTenantChange(v) {
      delete this.item.parent_tenant_id;
      delete this.item.vehicle_ids;
      if (v) {
        this.$store.dispatch("tenantsRelationship/list", {
          child_tenant_id: v,
        });

        // this.$store.dispatch("vehicleAssign/vehicleOptions", {
        //   tenant_id: v,
        // });
      }
    },
    onParentTenantChange(v) {
      delete this.item.vehicle_ids;
      if (v) {
        this.$store.dispatch("vehicleAssign/vehicleOptions", {
          tenant_id: v,
        });
      }
    },
  },
};
</script>
